import { Link } from "react-router-dom";
import { MapPin, Clock, Instagram } from "lucide-react";
import { STORE_INFO } from "@/lib/store";
import { StoreStatus } from "./StoreStatus";

const Info = ({ icon: Icon, label, children, testid }) => (
  <div className="flex items-start gap-3">
    <Icon className="mt-0.5 h-4 w-4 shrink-0 text-white" strokeWidth={1.6} />
    <div>
      <p className="mono text-[11px] uppercase tracking-[0.25em] text-zinc-400">{label}</p>
      <div data-testid={testid} className="mt-1.5 text-base text-white">{children}</div>
    </div>
  </div>
);

export const Footer = () => (
  <footer data-testid="footer-section" className="border-t border-white/10">
    <div className="mx-auto max-w-[1440px] px-5 sm:px-8 py-14">
      <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
        <img src="/brand/logo-white.png" alt="RC iPhones" className="h-24 w-auto self-start md:col-span-3" />
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-3 md:col-span-9">
          <Info icon={MapPin} label="Localização" testid="footer-location">
            <p>{STORE_INFO.city}</p>
            <p className="text-zinc-300">{STORE_INFO.serviceNote}</p>
          </Info>
          <Info icon={Clock} label="Atendimento" testid="footer-hours">
            <ul className="space-y-1">
              {STORE_INFO.schedule.map((r) => (
                <li key={r.label} className="flex gap-4">
                  <span className="w-20 text-zinc-300">{r.label}</span>
                  <span className="tabular-nums">{r.open} – {r.close}</span>
                </li>
              ))}
            </ul>
            <StoreStatus testid="footer-store-status" className="mt-3" />
          </Info>
          <Info icon={Instagram} label="Instagram" testid="footer-instagram">
            <a data-testid="footer-instagram-link" href={STORE_INFO.instagramUrl} target="_blank" rel="noopener noreferrer" className="link-underline hover:text-zinc-200">
              @{STORE_INFO.instagram}
            </a>
          </Info>
        </div>
      </div>
      <div className="mt-12 flex flex-col gap-3 border-t border-white/10 pt-6 pb-16 sm:pb-0 sm:pr-20 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-sm text-zinc-400">© {new Date().getFullYear()} RC iPhones. Todos os direitos reservados.</p>
        <div className="flex items-center gap-5">
          <Link data-testid="footer-track-link" to="/rastreio" className="text-sm text-zinc-300 underline-offset-4 hover:text-white hover:underline">Rastrear pedido</Link>
          <Link data-testid="footer-admin-link" to="/admin" className="text-xs text-zinc-400 underline-offset-4 hover:text-white hover:underline">Área do lojista</Link>
        </div>
      </div>
    </div>
  </footer>
);
